import { render, staticRenderFns } from "./SelectPlanTypes.vue?vue&type=template&id=4a8910d0"
import script from "./SelectPlanTypes.vue?vue&type=script&lang=js"
export * from "./SelectPlanTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports